import ChartTooltip from '../../ChartTooltip';
import { ProgressbarProps } from '../Progressbar/types';
import { StyledProgressbar } from './styles';

export interface BarProps extends ProgressbarProps {
  optionText: RichText;
  canSeeResults: boolean;
  className?: string;
}

const Bar = ({ label, value, color, optionText, canSeeResults, className }: BarProps) => {
  return (
    <ChartTooltip
      title={optionText}
      placement="left"
      PopperProps={{
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -6],
            },
          },
          {
            name: 'preventOverflow',
            options: {
              altBoundary: true,
            },
          },
        ],
      }}
    >
      <StyledProgressbar
        label={label}
        value={canSeeResults ? value : 0}
        color={color}
        className={className}
      />
    </ChartTooltip>
  );
};

export default Bar;
